import {
  getKeyValue,
  Link,
  Table,
  TableBody,
  TableCell,
  TableColumn,
  TableHeader,
  TableRow,
} from "@heroui/react";
import { api } from "@/lib/api-client";
import { t } from "@lingui/core/macro";
import { Outlet, Route, Routes } from "react-router";
import ManageApiKey from "./ManageApiKey";
import { LimeModal } from "@/Components/NextBase/LimeModal";
import { LimeAlert } from "@/Components/NextBase/LimeAlert";

const ApiKeys = () => {
  const { data: apiKeys, processedErrorMessage } =
    api.integrations.useGetApiKeys();

  const columns = [
    {
      label: t`Ime`,
      key: "name",
    },
    {
      label: t`Uporabnik`,
      key: "userName",
    },

    {
      label: t`Tipi`,
      key: "scopes",
    },
    {
      label: t`Ustvarjen`,
      key: "createdAt",
    },
  ];

  const rows = apiKeys?.apiKeys || [];

  return (
    <div className="flex flex-col gap-4 md:px-4">
      <LimeAlert message={processedErrorMessage}></LimeAlert>
      <Table shadow="none">
        <TableHeader>
          {columns.map((column) => (
            <TableColumn key={column.key}>{column.label}</TableColumn>
          ))}
        </TableHeader>
        <TableBody>
          {rows.map((row) => (
            <TableRow
              as={Link}
              href={`/dashboard/integrations/api/${row.id}`}
              key={row.id}
              className="cursor-pointer rounded-md hover:bg-gray-100"
            >
              {(columnKey) => (
                <TableCell key={columnKey}>
                  {getKeyValue(row, columnKey)}
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Outlet />
    </div>
  );
};

export default ApiKeys;
